import { EXPLORE_SCHEMES_USER_FLOW } from "../../../../constants/ExplorePage";
import { BACK, EDIT_NOMINEE, LUMPSUM, SIP, TERMS_AND_CONDITION } from "../../../../constants/investTransactPage";
import { ADD_NOMINEE } from "../../../../constants/NomineeModal";
import { CLOSE, SUBMIT } from "../../../../constants/OtpModal";
import GTM from "../../../../GTM";
import { TransactionRequestData } from "../../../../pages/transact/invest";

// Invest Page
export const triggerOnPageLoadGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.investPageLoad(fundName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.investPageLoad(fundName, invIdeaScheme.toString());
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageLoad(fundName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageLoad(fundName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
      GTM.investMore.onInvestMorePageLoad(fundName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investPageLoad(fundName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageLoad(fundName);
      break;
  }
};

export const triggerOnBackGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.investPageActionClick(fundName, BACK, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.investPageActionClick(fundName, invIdeaScheme.toString(), BACK, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageActionClick(fundName, BACK, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageOnClickEvent(fundName, BACK, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investPageOnClickEvent(fundName, BACK, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageActionClick(fundName, BACK, userFlow);
      break;
    // Note: No GTM function has been added in the sheet for invest more journey
  }
} 

export const triggerContinueClickGtmEvent = (userFlow: string, fundName: string, transactionData: TransactionRequestData, isLumpsum: boolean, invIdeaScheme?: string) => {
  const { amount, investmentId, selectedDividendOption } = transactionData;
  const paymentType = isLumpsum ? LUMPSUM : SIP;
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.investPageContinueClick(fundName, {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
        cd74: investmentId,
      }, userFlow, isLumpsum);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.investPageContinueClick(fundName, invIdeaScheme.toString(), {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
      }, userFlow, isLumpsum);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageContinueClick(fundName, {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
      }, userFlow, isLumpsum);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageOnContinueClick(fundName, {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
      }, userFlow, isLumpsum);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
      GTM.investMore.onClickInvestMorePageContinue(fundName, {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
      }, userFlow, isLumpsum);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investPageOnContinueClick(fundName, {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
        cd74: investmentId,
      }, userFlow, isLumpsum);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageContinueClick(fundName, {
        cd68: selectedDividendOption,
        cd69: paymentType,
        cd70: amount.toString(),
      }, userFlow, isLumpsum);
      break;
  }
};


export const triggerTermsAndConditionGtmEvent = ( userFlow: string , fundName: string, invIdeaScheme?: string) => {
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.investPageActionClick(fundName, TERMS_AND_CONDITION);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.investPageActionClick(fundName, invIdeaScheme.toString(), TERMS_AND_CONDITION);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageActionClick(fundName, TERMS_AND_CONDITION);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageOnClickEvent(fundName, TERMS_AND_CONDITION);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investPageOnClickEvent(fundName, TERMS_AND_CONDITION);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageActionClick(fundName, TERMS_AND_CONDITION);
      break;
    // Note: GTM function for Terms and condition not added for Invest more journey
  }
};

export const triggerAddNomineeGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.investPageActionClick(fundName, ADD_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.investPageActionClick(fundName, invIdeaScheme, ADD_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageActionClick(fundName, ADD_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageOnClickEvent(fundName, ADD_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE: 
      GTM.investBasisRiskProfile.investPageOnClickEvent(fundName, ADD_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageActionClick(fundName, ADD_NOMINEE)
      break;
  }
}

export const triggerEditNomineeGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.investPageActionClick(fundName, EDIT_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.investPageActionClick(fundName, invIdeaScheme, EDIT_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageActionClick(fundName, EDIT_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageOnClickEvent(fundName, EDIT_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investPageOnClickEvent(fundName, EDIT_NOMINEE)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageActionClick(fundName, EDIT_NOMINEE)
      break;
  }
}

// Nominee Modal
export const triggerNomineeModalPageLoadGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.nomineeModalPageLoad(fundName)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.nomineeModalPageLoad(fundName, invIdeaScheme)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageNomineeModalPageLoad(fundName)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageNomineeModalOnLoad(fundName)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.nomineeModalPageLoad(fundName)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageNomineeModalPageLoad(fundName);
      break;
  }
}
// action can be Close, Remove, Add Another Nominee, or Confirm Nominee
export const triggerNomineeModalActionGtmEvent = (userFlow: string, fundName: string, action: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.nomineeModalActionClick(fundName, action)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.nomineeModalActionClick(fundName, invIdeaScheme, action)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageNomineeModalActionClick(fundName, action)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageNomineeModalActionClick(fundName, action)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.nomineeModalActionClick(fundName, action)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageNomineeModalActionClick(fundName, action)
      break;
  }
}

// Verify OTP Modal
export const triggerOtpModalPageLoadGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.otpModalPageLoad(fundName, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.otpModalPageLoad(fundName, invIdeaScheme, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageOtpModalPageLoad(fundName, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageVerifyOtpModalOnLoad(fundName, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
      GTM.investMore.onOTPModalLoad(fundName, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.otpModalPageLoad(fundName, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageOtpModalPageLoad(fundName, userFlow);
      break;
  }
}

export const triggerCloseOtpModalGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
  // switch(userFlow) {
  //   case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
  //     GTM.explore.otpModalActionClick(fundName, CLOSE);
  //     break;
  //   case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
  //     GTM.investmentIdeas.otpModalActionClick(fundName, invIdeaScheme, CLOSE)
  //     break;
  //   case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
  //     GTM.saveTax.investPageOtpModalActionClick(fundName, CLOSE);
  //     break;
  //   case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
  //     GTM.planGoalsSip.investPageVerifyOtpModalActionClick(fundName, CLOSE);
  //     break;
  //   case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
  //     GTM.investMore.onCloseOtpModal(fundName);
  //     break;
  //   case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
  //     GTM.investBasisRiskProfile.otpModalActionClick(fundName, CLOSE);
  //     break;
  //   case EXPLORE_SCHEMES_USER_FLOW.NFO:
  //     GTM.nfo.investPageOtpModalActionClick(fundName, CLOSE);
  //     break;
  // }
}

export const triggerSubmitOtpModalGtmEvent = (userFlow: string, fundName: string, invIdeaScheme?: string) => {
switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.otpModalActionClick(fundName, SUBMIT, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.otpModalActionClick(fundName, invIdeaScheme, SUBMIT, userFlow)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageOtpModalActionClick(fundName, SUBMIT, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageVerifyOtpModalActionClick(fundName, SUBMIT, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
      GTM.investMore.onClickOTPSubmit(fundName, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.otpModalActionClick(fundName, SUBMIT, userFlow);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageOtpModalActionClick(fundName, SUBMIT, userFlow);
      break;
  }
}

export const getFundCategoryBasedOnRouterPath = (path?: string) => {
  //All GTM Calls based on window location url
  switch(path){
    case "/investmentIdeas":
    case "/explore/EQ?subCategory=ELF":
    case "/explore/HYB?subCategory=HMA":
    case "/explore/EQ?subCategory=EFC,FLC":
    case "/explore/OTH?subCategory=EIF":
    case "/explore/EQ,OTH?subCategory=INF,OFO":
    case "/explore/SOS?subCategory=SRF":
      return "investment ideas"
    case "/explore":
      return "funds category"
    case "/explore/EQ?subCategory=ELS":
      return "save tax elss"
    case "/explore/Equity":
      return "equity funds"
    default:
      return "funds category"
  } 
}

// Transaction Successful Page
export const triggerTransactionSuccessPageLoadGtmEvent = (userFlow: string, fundName: string, referenceId: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.successPageLoad(fundName, { cd71: referenceId });
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.successPageLoad(fundName, invIdeaScheme, { cd71: referenceId })
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageTransactionSuccesfulPageLoad(fundName,{ cd71: referenceId });
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageSuccessPageLoad(fundName, { cd71: referenceId })
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
      GTM.investMore.onInvestMoreSuccessPageLoad(fundName, { cd71: referenceId });
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investSuccessPageLoad(fundName, { cd71: referenceId });
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageTransactionSuccesfulPageLoad(fundName, { cd71: referenceId });
      break;
  }
}

export const triggerGoBackMessageClickGtmEvent = (userFlow: string, fundName: string, goBackMessage: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
      GTM.explore.successPageGoBackTextClick(fundName, goBackMessage);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.successPageGoBackTextClick(fundName, invIdeaScheme, goBackMessage)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.investPageTransactionSuccesfulGoBackTextClick(fundName, goBackMessage);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.planGoalsSip.investPageSuccessPageGoBackTextClick(fundName, goBackMessage)
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
      GTM.investMore.onClickBackToMyHoldings(fundName, goBackMessage);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investSuccessPageGoBackTextClick(fundName, goBackMessage);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.nfo.investPageTransactionSuccesfulGoBackTextClick(fundName, goBackMessage);
      break;
  }
}

export const triggerActionButtonsClickGtmEvent = (userFlow: string, fundName: string , actionButton: string, invIdeaScheme?: string) => {
  switch(userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_MORE:
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
    case EXPLORE_SCHEMES_USER_FLOW.NFO:
      GTM.explore.successPageActionButtonsClick(userFlow, fundName, actionButton);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.successPageActionButtonsClick(fundName, invIdeaScheme, actionButton);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVEST_BASIS_RISK_PROFILE:
      GTM.investBasisRiskProfile.investSuccessActionButtonsClick(fundName, actionButton);
      break;
  }
}